import { Box, Typography } from "@mui/material";
import { Check, X } from "lucide-react";

interface PasswordRulesProps {
  password: string;
}

const PasswordRules: React.FC<PasswordRulesProps> = ({ password = "" }) => {
  const rules = [
    {
      label: "12–20 characters",
      valid: password.length >= 12 && password.length <= 20,
    },
    {
      label: "At least one uppercase letter",
      valid: /[A-Z]/.test(password),
    },
    {
      label: "At least one lowercase letter",
      valid: /[a-z]/.test(password),
    },
    {
      label: "At least one number",
      valid: /\d/.test(password),
    },
    {
      label: "At least one special character",
      valid: /[^A-Za-z0-9]/.test(password),
    },
  ];

  return (
    <Box className="space-y-1 mt-2">
      {rules.map((rule, index) => (
        <Box key={index} className="flex items-center gap-2">
          {rule.valid ? (
            <Check className="text-green-600 w-4 h-4" />
          ) : (
            <X className="text-red-600 w-4 h-4" />
          )}
          <Typography
            variant="body2"
            className={rule.valid ? "text-green-600" : "text-red-600"}
          >
            {rule.label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default PasswordRules;
